module.exports = __webpack_public_path__ + "img/1544709845.fe6c1152.jpg";